export default __webpack_public_path__ + "static/media/ARIIA.e06ab774.png";